export const properties = {
    ID_PAGE_TITLE : 'tituloPagina'
}

export const texts  = {
    PAGE_TITLE : 'Compatibilidades de la Oficina Virtual',
    TABLE_TITLE: 'Compatibilidades Software/Versión'
}
